import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";

// Import components
import MyOrders from "../../../pages/Order/MyOrders";
import AddressBook from "./TapsComponent/AddressBook";

// Configuration for the tabs
const taps = {
  my_orders: { name: "My Orders", component: MyOrders },
  address_book: { name: "Address Book", component: AddressBook },
};

const TapContainer = () => {
  const [activeTab, setActiveTab] = useState("my_orders");

  useEffect(() => {
    const search = new URLSearchParams(window.location.search);
    if (search.has("tap")) setActiveTab(search.get("tap"));
  }, []);

  // Get the component for the current active tab
  const ActiveComponent = taps[activeTab].component;

  return (
    <section>
      <nav>
        <ul className="flex w-full flex-wrap items-center gap-[12px] md:gap-[50px] md:pl-[50px]">
          {Object.keys(taps).map((key) => (
            <li
              key={key} // Use key instead of index
              className={`hover:text-blue-500 cursor-pointer border-b-2 border-solid hover:border-blue-500 ${
                activeTab === key
                  ? "text-blue-500 border-blue-500"
                  : "border-transparent"
              }`}
            >
              <NavLink
                to={`/me/profile?tap=${key}`}
                className="hover:text-inherit"
                onClick={() => setActiveTab(key)}
              >
                {taps[key].name}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>

      {/* Tab Content */}
      <article className="w-full px-20  py-[30px] border bg-white rounded-lg">
        <ActiveComponent />
      </article>
    </section>
  );
};

export default TapContainer;
